import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['MeasurementParameter'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMeasurementParameterById: build.query<
        GetMeasurementParameterByIdApiResponse,
        GetMeasurementParameterByIdApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementParameter/${queryArg}` }),
        providesTags: ['MeasurementParameter'],
      }),
      getMeasurementParameterGetAll: build.query<
        GetMeasurementParameterGetAllApiResponse,
        GetMeasurementParameterGetAllApiArg
      >({
        query: () => ({ url: `/MeasurementParameter/get-all` }),
        providesTags: ['MeasurementParameter'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measurementParameterApi };
export type GetMeasurementParameterByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementParameterExternalDto;
export type GetMeasurementParameterByIdApiArg = number;
export type GetMeasurementParameterGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementParameterExternalDto;
export type GetMeasurementParameterGetAllApiArg = void;
export type ApiCommonExternalDtoMeasurementParameterExternalDto = {
  id?: number;
  name: string;
  technicalName: string;
  unit?: string | null;
  category: string;
  subcategory: string;
  categoryPath: string;
  isUsedForPqIndex: boolean;
  isUsedForPlanningLevel: boolean;
  isDisplayedForHarmonicBackgroundLevel: boolean;
  isUsedForTAR: boolean;
  isUsedForDailyCorrelationCalculator: boolean;
  isUsedForTrendCalculator: boolean;
  aggregationIntervalId: number;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementParameterExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementParameterExternalDto;
  externalDtos?: ApiCommonExternalDtoMeasurementParameterExternalDto[] | null;
};
export const {
  useGetMeasurementParameterByIdQuery,
  useLazyGetMeasurementParameterByIdQuery,
  useGetMeasurementParameterGetAllQuery,
  useLazyGetMeasurementParameterGetAllQuery,
} = injectedRtkApi;
